// extracted by mini-css-extract-plugin
export var label = "expenses-page-module--label--0c13f";
export var selectRow = "expenses-page-module--selectRow--55763";
export var sliderRow = "expenses-page-module--sliderRow--fa29f";
export var sliderTime = "expenses-page-module--sliderTime--aa98e";